import React, { useState } from 'react';

// NOTA: A função 'onLogin' e 'onNavigateToRegister' virão do App.js
const LoginView = ({ onLogin, onNavigateToRegister }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);
        try {
            // A lógica de login do Firebase será chamada através da prop 'onLogin'
            await onLogin(email, password);
            // Se o login for bem-sucedido, o App.js irá redirecionar
        } catch (err) {
            setError('Falha ao entrar. Verifique o seu email e palavra-passe.');
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50">
            <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-2xl shadow-lg">
                <h2 className="text-3xl font-bold text-center text-gray-800">
                    Bem-vindo de Volta!
                </h2>
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label htmlFor="email" className="form-label sr-only">Email</label>
                        <input
                            id="email"
                            name="email"
                            type="email"
                            autoComplete="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D7BFBD]"
                            placeholder="Email"
                        />
                    </div>
                    <div>
                        <label htmlFor="password" aria-label="Palavra-passe" className="form-label sr-only">Palavra-passe</label>
                        <input
                            id="password"
                            name="password"
                            type="password"
                            autoComplete="current-password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D7BFBD]"
                            placeholder="Palavra-passe"
                        />
                    </div>

                    {error && <p className="text-sm text-center text-red-600">{error}</p>}

                    <div>
                        <button
                            type="submit"
                            disabled={isLoading}
                            className="w-full custom-button py-3 font-semibold rounded-lg shadow-sm disabled:opacity-50"
                        >
                            {isLoading ? 'A entrar...' : 'Entrar'}
                        </button>
                    </div>
                </form>
                <p className="text-sm text-center text-gray-600">
                    Ainda não tem uma conta?{' '}
                    <button onClick={onNavigateToRegister} className="font-semibold text-[#BF9A91] hover:underline">
                        Crie uma aqui
                    </button>
                </p>
            </div>
        </div>
    );
};

export default LoginView;
